<div class="ag-cell-value" [hidden]="!text" (click)="onUserAction();" [innerHTML]="sanitizerHtml(text)"></div>